import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import NavMenuOption from './NavMenuOption';
import NavAdminPanel from '../NavAdminPanel';
import NavFormsPanel from '../NavFormsPanel';
import NavCategoryPanel from '../NavCategoryPanel';
import NavWorkspacePanel from '../NavWorkspacePanel';
import NavSetsPanel from '../NavSetsPanel';
import NavThesaurusPanel from '../NavThesaurusPanel';
import { isWorkbench } from '../../utils/piction';
import appConfig from '../../appConfig';

function NavOptions(props) {
  const { intl } = props;
  const externalNavLinks = appConfig.navExternalLink ? [] : null;
  if (Array.isArray(appConfig.navExternalLink)) {
    appConfig.navExternalLink.forEach((navLink) => {
      if (navLink.title && navLink.url) {
        externalNavLinks.push(
          <li
            className={classNames('nav-options__link',
            `nav_link-${navLink.title.toLowerCase().replace(' ', '_')}`)}
            onClick={() => props.onExternalLinkClick(appConfig.navExternalLink)}
          >
            <NavMenuOption navLabel={navLink.title}>
              <i className="nav-options__icon nav-options__icon--info" aria-hidden="true" />
            </NavMenuOption>
          </li>);
      }
    });
  } else if (appConfig.navExternalLink && appConfig.navExternalLink.title &&
    appConfig.navExternalLink.url) {
    externalNavLinks.push(
      <li
        className={classNames('nav-options__link')}
        onClick={() => props.onExternalLinkClick(appConfig.navExternalLink)}
      >
        <NavMenuOption navLabel={appConfig.navExternalLink.title}>
          <i className="nav-options__icon nav-options__icon--info" aria-hidden="true" />
        </NavMenuOption>
      </li>
      );
  }
  return (
    <ul className="nav-options">
      { appConfig.removeHomeButton ? null :
      <li className={classNames('nav-options__link')} onClick={props.onHomeClick}>
        <NavMenuOption navLabel={intl.formatMessage({ id: 'navOptions.homeHeader' })}>
          <i className="nav-options__icon nav-options__icon--home" aria-hidden="true" />
        </NavMenuOption>
      </li>
      }
      {
        isWorkbench() && appConfig.menuOptions.adminMenu &&
        appConfig.menuOptions.adminMenu.length > 0 ?
            <li
              className={classNames('nav-options__link',
                { 'nav-options__link--selected':
                  (props.selectedComponent &&
                    props.selectedComponent.type === <NavAdminPanel />.type) })}
              onClick={() => props.onClick(<NavAdminPanel />)}
            >
              <NavMenuOption navLabel={intl.formatMessage({ id: 'navOptions.adminHeader' })}>
                <i className="nav-options__icon nav-options__icon--admin" aria-hidden="true" />
              </NavMenuOption>
            </li>
          : null
      }
      { appConfig.removeCategories ? null :
        <li
          className={classNames('nav-options__link', {
            'nav-options__link--selected':
          (props.selectedComponent &&
            props.selectedComponent.type === <NavCategoryPanel />.type) })}
          onClick={() => props.onClick(<NavCategoryPanel />)}
        >
          <NavMenuOption navLabel={intl.formatMessage({ id: 'navOptions.categoryHeader' })}>
            <i className="nav-options__icon nav-options__icon--cat" aria-hidden="true" />
          </NavMenuOption>
        </li>}
      {appConfig.removeWorkspaces ? null :
        <li
          className={classNames('nav-options__link', { 'nav-options__link--selected':
              (props.selectedComponent &&
                props.selectedComponent.type === <NavWorkspacePanel />.type) })}
          onClick={() => props.onClick(<NavWorkspacePanel />)}
        >
          <NavMenuOption navLabel={intl.formatMessage({ id: 'navOptions.workspaceHeader' })}>
          <i className="nav-options__icon nav-options__icon--work" aria-hidden="true" />
          </NavMenuOption>
        </li>
      }
      {(appConfig.menuOptions &&
      appConfig.menuOptions.formsMenu &&
      appConfig.menuOptions.formsMenu.enabled) ?
          <li
            className={classNames('nav-options__link', {
              'nav-options__link--selected':
            (props.selectedComponent &&
              props.selectedComponent.type === <NavFormsPanel />.type) })}
            onClick={() => props.onClick(<NavFormsPanel />)}
          >
            <NavMenuOption navLabel={intl.formatMessage({ id: 'navOptions.formsHeader' })}>
            <i className="nav-options__icon nav-options__icon--forms" aria-hidden="true" />
            </NavMenuOption>
          </li>
        : null}
      {appConfig.useHighlights ?
          <li
            className={classNames('nav-options__link',
              { 'nav-options__link--selected':
                (props.selectedComponent &&
                  props.selectedComponent.type === <NavSetsPanel />.type) })}
            onClick={() => props.onClick(<NavSetsPanel />)}
          >
            <NavMenuOption navLabel={intl.formatMessage({ id: 'navOptions.setsHeader' })}>
            <i className="nav-options__icon nav-options__icon--set" aria-hidden="true" />
            </NavMenuOption>
          </li>
        : null}
      {appConfig.thesaurus && appConfig.thesaurus.show ?
          <li
            className={classNames('nav-options__link',
              { 'nav-options__link--selected':
                (props.selectedComponent &&
                  props.selectedComponent.type === <NavThesaurusPanel />.type) })}
            onClick={() => props.onClick(<NavThesaurusPanel />)}
          >
            <NavMenuOption
              navLabel={appConfig.thesaurus.mainLabel ? appConfig.thesaurus.mainLabel :
              intl.formatMessage({ id: 'navOptions.thesaurusHeader' })}
            >
              <i className="nav-options__icon nav-options__icon--thes" aria-hidden="true" />
            </NavMenuOption>
          </li>
        : null}
      {externalNavLinks}
    </ul>
  );
}

NavOptions.propTypes = {
  selectedComponent: PropTypes.element,
  onClick: PropTypes.func,
  onHomeClick: PropTypes.func,
  isNavExpanded: PropTypes.bool,
  onExternalLinkClick: PropTypes.func,
};

export default injectIntl(NavOptions);



// WEBPACK FOOTER //
// ./src/js/components/Nav/NavOptions.jsx